import _ from 'lodash';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import TrendLabels from '../../components/chart/TrendLabels';
import { edit } from '../../state/actions/entity';
import * as fromState from '../../state/reducers';
import { ENTITY_PROPERTY, ENTITY_TYPE } from '../../utils/constants';

const mapStateToProps = createSelector(
  [
    (state, { trend }) => trend,
    state => fromState.getLabels(state, ENTITY_TYPE.TREND),
    state => fromState.getIsEditing(state, ENTITY_TYPE.TREND)
  ],
  (trend, labels, isLoading) => ({
    trend,
    labels: _.chain(labels)
      .map(ENTITY_PROPERTY.LABEL.NAME)
      .concat(trend
        ? trend.labels
        : [])
      .uniq()
      .value(),
    isLoading
  })
);

const mapDispatchToProps = {
  onChange: trend => edit(ENTITY_TYPE.TREND, trend)
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendLabels);